export function diferencaHorasMinutos(dataAtual: Date, dataFornecida: string): string {
  let dataAtualObj = new Date(dataAtual);
  let dataFornecidaObj = new Date(dataFornecida);

  let diferencaMs = dataFornecidaObj.getTime() - dataAtualObj.getTime();

  let horas = Math.floor(diferencaMs / (1000 * 60 * 60));
  let minutos = Math.floor((diferencaMs % (1000 * 60 * 60)) / (1000 * 60));
  
  return horas + ':' + minutos;
}
